import { SVGProps } from 'react'

const Extra = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 375.21 375.21"
    width="1em"
    height="1em"
    {...props}
  >
    <defs>
      <linearGradient
        id="extraCircle"
        x1={190.39}
        x2={184.29}
        y1={-29.48}
        y2={445.95}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#208fff" />
        <stop offset={1} stopColor="#2d65ff" />
      </linearGradient>
      <style>{'.cls-3{opacity:.25}'}</style>
    </defs>
    <g id="\u56FE\u5C42_2" data-name="\u56FE\u5C42 2">
      <g id="\u56FE\u5C42_2-2" data-name="\u56FE\u5C42 2">
        <circle
          cx={187.6}
          cy={187.6}
          r={187.6}
          style={{
            fill: 'url(#extraCircle)',
          }}
        />
        <path
          d="M252.93 234.63 224.11 280h-34.57l48-62.55L189.26 155h33.33l30.32 41.28h.77L282.41 155h31.82l-46 62.46 46 62.54h-32.3l-28.23-45.37Z"
          style={{
            opacity: 0.75,
            fill: '#fff',
          }}
        />
        <path
          d="m274.28 209.32-6 8.2-14.69-21.19h.11l5.79-8.34 14.79 21.33z"
          className="cls-3"
        />
        <path
          d="M171.81 252H124.5c-10.29 0-18.75-2.64-25.12-7.83a25.1 25.1 0 0 1-9.53-20.38c0-9.23 3.36-15.92 10.25-20.44s17.93-6.85 32.68-6.85h28.06v-25.2h-28.06c-12 0-21.88-2.46-29.35-7.32s-11.05-11.44-11.05-20.2c0-7.46 2.54-13.19 7.55-17s12.58-5.88 22.28-5.88h49.63V95.19h-53.09c-16.86 0-30.42 4.1-40.3 12.18s-15 19.31-15 33.21c0 9.8 2.33 18.53 6.93 25.94a41.64 41.64 0 0 0 17.92 15.82 40.1 40.1 0 0 0-19.7 14.92c-5.08 7.35-7.66 16.51-7.66 27.25 0 16.18 6 29.25 17.86 38.84s27.39 14.37 46.39 14.37l46.69.11Z"
          style={{
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: 5,
            fill: '#fff',
          }}
        />
        <path
          d="M122.83 199.37c-.27.43-16.94-4.15-24.49-8a155.56 155.56 0 0 1-15.63-9.28 37 37 0 0 0-8.27 5.25A57.45 57.45 0 0 0 95.2 198c13.1 3.61 27.63 1.37 27.63 1.37Z"
          className="cls-3"
        />
      </g>
    </g>
  </svg>
)
export default Extra
